import React from 'react'

export const InlineCode = (props) => (
    <code
        {...props}
        className="dark:bg-gray-accent-dark dark:text-white bg-gray-accent-light text-inherit p-1 rounded"
    />
)
